import { gql } from '@apollo/client';
import useGQLQuery from 'src/lib/graphql/hooks/useGQLQuery';
import { EP_ANCESTORS_DETAILS_FIELDS } from '../common/fragments/ancestorsDetails';
const SUBJECT_DETAILS_QUERY = gql `
  query EP_SubjectDetails($subjectID: ID!) {
    ep_subjectDetails(subjectID: $subjectID) {
      id
      data {
        title
      }
      attributes {
        totalQuestionCount
        answeredQuestionCount
      }
      type
      ancestorsDetails {
        ...EPAncestorsDetailsFields
      }
    }
  }

  ${EP_ANCESTORS_DETAILS_FIELDS}
`;
export function useSubjectDetailsQuery(subjectID, options) {
    return useGQLQuery(SUBJECT_DETAILS_QUERY, {
        variables: {
            subjectID,
        },
        ...options,
    });
}
